const environment = {
  dev: {
    serverUrl: 'https://descubramanaus.sidialab.com/api/v1'
  },
  test: {
    serverUrl: 'https://descubramanaus.test.sidialab.com/api/v1'
  },
  hom: {
    serverUrl: 'https://descubra-hom.manaus.am.gov.br/api/v1'
  },
  prod: {
    serverUrl: 'https://descubra.manaus.am.gov.br/api/v1'
  },
  labhom: {
    serverUrl: 'https://descubramanaus.hom.sidialab.com/api/v1'
  },
  'aws-test': {
    serverUrl: 'https://descubramanaus.test.sidialab.com/api/v1'
  },
  // default: {
  //   serverUrl: 'https://descubra.manaus.am.gov.br/api/v1'
  // },
  default: {
    // With docker -> remove port
    // Without docker -> set port 3001
    serverUrl: 'http://localhost/api/v1'
  }
};

let config = () => {
  return environment[process.env.REACT_APP_ENV] || environment.default;
}

export const mainPath = config().serverUrl
// export const apiPath = mainPath + '/api';
